import { render, staticRenderFns } from "./CitasDetalle.vue?vue&type=template&id=5b2de5cd&"
import script from "./CitasDetalle.vue?vue&type=script&lang=js&"
export * from "./CitasDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports